module.exports = __webpack_public_path__ + "media/images/client/AdContacts/dislike-50b37aa981243af9e0e53e54f21bef3f.svg";